document.addEventListener('DOMContentLoaded', () => {
  const scrollToTopBtn = document.getElementById("scrollToTop");
  if (!scrollToTopBtn) return;

  const isProductPage = document.body.classList.contains('product');
  const isMobile = window.innerWidth < 750;

  let isVisible = false;

  // 表示・非表示関数（共通）
  const show = () => {
    scrollToTopBtn.style.opacity = "1";
    scrollToTopBtn.style.pointerEvents = "auto";
    isVisible = true;
  };

  const hide = () => {
    scrollToTopBtn.style.opacity = "0";
    scrollToTopBtn.style.pointerEvents = "none";
    isVisible = false;
  };

  // スムーズスクロール
  scrollToTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  if (isProductPage) {
    // 商品ページは全デバイスで常時表示
    show();
  } else if (isMobile) {
    // スマホ：ページ最下部で表示
    const toggleMobile = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const isAtBottom = scrollTop + windowHeight >= documentHeight - 50; // 誤差少し残す

      if (isAtBottom && !isVisible) {
        show();
      } else if (!isAtBottom && isVisible) {
        hide();
      }
    };

    toggleMobile(); // 初期チェック
    window.addEventListener('scroll', toggleMobile);
  } else {
    // PC：300px以上スクロールで表示
    const triggerOffset = 300;

    const toggleDesktop = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > triggerOffset && !isVisible) {
        show();
      } else if (scrollTop <= triggerOffset && isVisible) {
        hide();
      }
    };

    toggleDesktop(); // 初期チェック
    window.addEventListener('scroll', toggleDesktop);
  }
});
